import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { AddToBlaclistComponent } from './add-to-blaclist.component';
import { RoleGuard } from '../../../_guards/role.guard';

const routes: Routes = [
  {
      path     : 'addtoblacklist',
      component: AddToBlaclistComponent,
      data :{
        permission:{
            only :['role1','role2']
        }
    },
      canActivate:[AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    AddToBlaclistComponent
  ],
  providers:[
      AuthGuard,RoleGuard
  ]
})
export class AddToBlaclistModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/add-to-blaclist/add-to-blaclist.module.ts